<template>
  <vx-card>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

<!--        <div class="vx-row mb-3" v-if="form.raw_material_stage">-->
<!--          <div class="vx-col w-full">-->
<!--            <vs-chip class="float-right mb-8" transparent color="dark">-->
<!--              STAGE: {{ form.raw_material_stage }}-->
<!--            </vs-chip>-->
<!--          </div>-->
<!--        </div>-->
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0 pt-6">
            <vs-alert color="dark" active="false">
              <small>ITS product code: &nbsp;&nbsp;</small>
              {{ form.company_product_code ? form.category.prefix + '-' + form.company_product_code : '' }}
            </vs-alert>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">

            <ValidationProvider vid="company_product_name" name="company_product_name" rules=""
                                v-slot="{ errors }">
              <small class="label">ITS Product Name</small>
              <vs-input v-model="form.company_product_name" name="company_product_name" class="w-full required"
                        label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather" :disabled="form.status.name !== 'Approved'"/>
            </ValidationProvider>

            <!-- <vs-alert color="dark" active="false">
              <small>{{$store.getters.systemName | capitalize}} Product Name: &nbsp;&nbsp;</small> {{ form.company_product_name }}
            </vs-alert> -->
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="supplier_product_code" name="supplier_product_code" rules=""
                                v-slot="{ errors }">
              <small class="label">Supplier Product Code</small>
              <vs-input v-model="form.supplier_product_code" name="supplier_product_code" class="w-full required"
                        label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="supplier_product_name" name="supplier_product_name" rules="" v-slot="{ errors }">
              <small class="label">Supplier Product Name</small>
              <vs-input name="supplier_product_name" v-model="form.supplier_product_name" class="w-full required"
                        label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="alternative_chemical_name" name="alternative_chemical_name" rules=""
                                v-slot="{ errors }">
              <small class="label">Alternative / Chemical Name</small>
              <vs-input name="alternative_chemical_name" v-model="form.alternative_chemical_name"
                        class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider vid="country_processing" name="country_processing" rules="required" v-slot="{ errors }">
              <small class="label">Country of Processing</small>
              <v-select multiple :filter-by="myFilter" :clearable="false" name="country_processing" placeholder="" label="name"
                        v-model="form.country_processing" :reduce="option => option.id" :options="countryCodes"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{ option.name }} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="form.country_processing === 'China'">
            <ValidationProvider vid="china_province" name="china_province" rules="" v-slot="{ errors }">
              <small class="label">If China, please state Province?</small>
              <vs-input name="china_province" v-model="form.china_province" class="w-full required" label=""
                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="raw_material_stage" name="raw_material_stage" rules="required" v-slot="{ errors }">
              <small class="label">Stage (development, production)</small>
              <v-select name="raw_material_stage" :closeOnSelect="true" v-model="form.raw_material_stage"
                        :options="['production', 'development']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="manufacturing_site" name="manufacturing_site" rules="required" v-slot="{ errors }">
              <small class="label">Manufacturing Sites</small>
              <v-select multiple :clearable="false" name="manufacturing_site" placeholder="" label="site_name"
                        v-model="form.manufacturing_site" :reduce="option => option.id" :options="sites"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{ option.site_name }} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="nominal_code" name="nominal_code" rules="" v-slot="{ errors }">
              <small class="label">Nominal Code</small>
              <v-select :clearable="false" name="nominal_code" placeholder=""
                        label="name" v-model="form.sage_nominal_code_id" :reduce="option => option.id"
                        :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <!--        <div class="vx-row mb-3">-->
        <!--          <div class="vx-col md:w-1/2 w-full md:mb-0">-->
        <!--            <ValidationProvider vid="similar_raw_materials" name="similar_raw_materials" rules="" v-slot="{ errors }">-->
        <!--              <small class="label">45Similar RM</small>-->
        <!--              <v-select-->
        <!--                :closeOnSelect="false" :clearable="false" multiple name="formulation_items" placeholder=""-->
        <!--                label="company_product_code" v-model="form.similar_raw_materials" :reduce="option => option.id"-->
        <!--                :options="similar_rms" :dir="$vs.rtl ? 'rtl' : 'ltr'">-->
        <!--                <template slot="no-options">-->
        <!--                  type to search products-->
        <!--                </template>-->
        <!--                <template slot="option" slot-scope="option">-->
        <!--                  <div class="d-center">-->
        <!--                    <span>PRODUCT CODE: <strong>{{ option.company_product_code || '-' }}</strong></span> <br>-->
        <!--                    <small>PRODUCT NAME : <strong>{{ option.company_product_name || '-' }}</strong></small> <br>-->
        <!--&lt;!&ndash;                    <small>Supplier prod name : <strong>{{ option.supplier_product_name }}</strong></small> <br>&ndash;&gt;-->
        <!--                  </div>-->
        <!--                </template>-->
        <!--                <template slot="selected-option" slot-scope="option">-->
        <!--                  <div class="selected d-center">-->
        <!--                    {{ option.company_product_code }} - {{option.company_product_name}}-->
        <!--                  </div>-->
        <!--                </template>-->
        <!--              </v-select>-->
        <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
        <!--            </ValidationProvider>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_food_grade" name="is_food_grade" rules="" v-slot="{ errors }">
              <small class="label">Food Grade?</small>
              <vs-switch v-model="form.is_food_grade" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_food_grade" vid="is_food_grade_comment" name="is_food_grade_comment"
                                rules="" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_food_grade_comment" class="w-full" v-model="form.is_food_grade_comment"
                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_compliant_food_law" name="is_compliant_food_law" rules="" v-slot="{ errors }">
              <small class="label">Compliant with General Food Law (Regulation (EC) No 178/2002)</small>
              <vs-switch v-model="form.is_compliant_food_law" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_compliant_food_law" vid="is_compliant_food_law_comment"
                                name="is_compliant_food_law_comment" rules="" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_compliant_food_law_comment" class="w-full"
                        v-model="form.is_compliant_food_law_comment" :danger="!!errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-1">
          <div class="vx-col w-full">
            <small class="label">Additional Information</small>
            <vs-textarea v-model="form.additional_information"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <small class="label">Notes</small>
            <vs-textarea v-model="form.notes"/>
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2" v-can="'create-edit-supplier-raw-materials'">Save Changes</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
const SageSettingsRepository = RepositoryFactory.get('sage_settings');
const DropDownRepository = RepositoryFactory.get('drop_down')


import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
import RawMaterialForm from "@/mixins/RawMaterialForm";

export default {
  name: "SupplierManufacturingHome",
  components: {
    'v-select': vSelect
  },
  data() {
    return {
      form: {
        is_food_grade: false,
        is_compliant_food_law: false,
        status: {
          name: ''
        }
      },
      id: null,
      countryCodes: [],
      site_ids: [],
      site_names: [],
      status: {},
      sites: [],
      supplierId: '',
      similar_rms: [],
      sage_nominal_codes:[]
    }
  },
  props : {
    isCompleted: { default: false },
  },
  mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
  methods: {
    async onClickNext() {
      this.$emit('notify', 1)
    },
    async onClickMarkAsComplete() {
      this.$emit('mark-as-complete', 'is_raw_material_marked_completed')
    },
    onClickSubmit() {
      this.$mixinsOpenUpdateConfirm()
    },
    async onClickUpdate() {
      this.$vs.loading()
      try {
        const payload = this.form
        // if (payload.similar_raw_materials.length > 0) {
        //   payload.similar_raw_materials =  payload.similar_raw_materials
        // } else {
        //   payload.similar_raw_materials =  []
        // }

        const data = (await SupplierRawMaterialRepository.updateRawMaterialDetails(this.id, payload))
        this.showSuccessMessage('Raw Material Details Updated!')
        location.reload();
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async loadCountrCode() {
      const {data} = (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes = data
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },
    statusColorFactory(id) {
      switch (id) {
        case 1:
          return 'danger'
        case 2:
          return 'warning'
        case 3:
          return 'success'
        default:
          return 'danger'
      }
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async loadManufacturingSites() {
      this.$vs.loading()
      try {
        const {data} = await DropDownRepository.getManufacturingSites(this.supplierId,this.filterQuery)
        this.sites = data.data
        this.meta = data.meta
      } catch (e) {

      }
      this.$vs.loading.close()
    },
  },
  async mounted() {
    this.$vs.loading()

    this.id = this.$route.params.id
    await this.loadCountrCode()
    await this.getSageNominalCodes()

    // this.supplierId = this.$route.params.supplierId

    const {data} = (await SupplierRawMaterialRepository.getRawMaterialDetails(this.id)).data
    this.form = data
    this.form.sage_nominal_code_id = data.sage_nominal_code.id
    this.supplierId = this.form.supplier.id

    await this.loadManufacturingSites()

    const status = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
    // const similar_rms = (await SupplierRawMaterialRepository.getSimilarRawMaterialList(this.id)).data

    this.status = status.data
    // this.similar_rms = similar_rms.data
    // this.form.similar_raw_materials = this.form.similarRawMaterials.map((n) => n.id)
    this.form.manufacturing_site = this.form.manufacturing_site.map((m) => m.id)
    this.form.country_processing = this.form.country_processing.map((m) => m.id)

    this.$vs.loading.close()
  }

}
</script>

<style scoped>

</style>
